import { useStyledTheme } from '@equifinance/shared';
import { BrokerUserStatus } from '../../../contexts/broker';
import { StatusDefaultLabel } from '../../BrokeragesTable/BrokerageStatus';

export default function BrokerUserStatusLabel({ status }: { status: keyof typeof BrokerUserStatus }) {
  const theme = useStyledTheme();

  const colors = (status: keyof typeof BrokerUserStatus) => {
    switch (status) {
      case 'ACTIVE':
        return [theme.colours.primary[3], theme.colours.neutral[10]];
      case 'INACTIVE':
        return [theme.colours.neutral[4], theme.colours.neutral[10]];
      case 'PENDING':
        return [theme.colours.primary[7], theme.colours.primary[1]];
      case 'LOCKEDOUT':
        return [theme.colours.neutral[7], theme.colours.neutral[2]];
      case 'OPEN':
        return [theme.colours.neutral[10], theme.colours.primary[1]];
      default: return [theme.colours.primary[3], theme.colours.neutral[10]];
    }
  };

  const [background, color] = colors(status);

  return (
    <StatusDefaultLabel background={background} color={color}>
      {BrokerUserStatus[status]}
    </StatusDefaultLabel>
  );
}
